export const get = (obj: object, path: string, def?: any) => {
  const res = path
    .replace(/\[/g, '.')
    .replace(/\]/g, '')
    .replace(/^\./, '')
    .split('.')
    .reduce((prev: any, curr) => {
      return prev && prev[curr]
    }, obj)

  return res === undefined ? def : res
}
